import React, { useState } from 'react';
import classNames from 'classnames';
import ProptTypes from 'prop-types';

import TitleSalaryOnlyStatesMap from 'components/statesMap/StateLevelForSalaryPage/titleSalaryOnlyStatesMap';

import TitleSalaryStatesMap from '../../components/statesMap/countyLevel/titleSalaryStatesMap';

import classes from './salaryMapSection.module.css';

const propTypes = {
  criteria: ProptTypes.objectOf(ProptTypes.any),
  onMapLoadError: ProptTypes.func,
  salaryStatesMapWidgetUrl: ProptTypes.string,
  salaryOnlyStatesMapWidgetUrl: ProptTypes.string,
  salaryStatesMapOriginalUrl: ProptTypes.string,
  salaryOnlyStatesMapOriginalUrl: ProptTypes.string,
};

const defaultProps = {
  criteria: {},
  onMapLoadError: () => {},
  salaryStatesMapWidgetUrl: '',
  salaryOnlyStatesMapWidgetUrl: '',
  salaryStatesMapOriginalUrl: '',
  salaryOnlyStatesMapOriginalUrl: '',
};

const SalaryMapSection = (props) => {
  const {
    criteria: { title, careerTitlePlural, nationalAverageAnnualSalary },
    onMapLoadError,
    salaryStatesMapWidgetUrl,
    salaryOnlyStatesMapWidgetUrl,
    salaryStatesMapOriginalUrl,
    salaryOnlyStatesMapOriginalUrl,
    articleDataContent,
    sectionTitle,
  } = props;

  const [currentFilter, setCurrentFilter] = useState('state');

  const careerTitlePluralLower = careerTitlePlural ? careerTitlePlural.toLowerCase() : '';

  const headerTitle = sectionTitle != null ? sectionTitle : `Average ${title} Salary By State`;

  return (
    <>
      {!!headerTitle && <h2 className="brandonH2 z-mb-48 w-730"> {headerTitle}</h2>}
      {articleDataContent && articleDataContent.content ? (
        <div
          className="w-730 z-mb-48"
          dangerouslySetInnerHTML={{
            __html: articleDataContent.content,
          }}
        />
      ) : (
        <p className="z-mb-48 w-730">
          {`The darker areas on the map show where ${careerTitlePluralLower} earn the highest salaries across all 50 states.`}
        </p>
      )}
      <ul className="pl-0 mb-4">
        <li
          className={classNames(classes['mapFilter'], {
            [classes['activeFilter']]: currentFilter === 'state',
          })}
          onClick={() => setCurrentFilter('state')}
        >
          State View
        </li>
        <li
          className={classNames(classes['mapFilter'], {
            [classes['activeFilter']]: currentFilter === 'county',
          })}
          onClick={() => setCurrentFilter('county')}
        >
          County View
        </li>
      </ul>
      {currentFilter === 'county' && (
        <TitleSalaryStatesMap
          title={title}
          onMapLoadError={onMapLoadError}
          embedWidgetUrl={salaryStatesMapWidgetUrl}
          originalUrl={salaryStatesMapOriginalUrl}
          isEmbeddable
        />
      )}
      {currentFilter === 'state' && (
        <TitleSalaryOnlyStatesMap
          title={title}
          onMapLoadError={onMapLoadError}
          embedWidgetUrl={salaryOnlyStatesMapWidgetUrl}
          originalUrl={salaryOnlyStatesMapOriginalUrl}
          isEmbeddable
          nationalAverageAnnualSalary={nationalAverageAnnualSalary}
        />
      )}
    </>
  );
};

SalaryMapSection.propTypes = propTypes;
SalaryMapSection.defaultProps = defaultProps;

export default SalaryMapSection;
